// extracted by mini-css-extract-plugin
export default {"RichTextElementContainer":"RMSChoosedImageElement_RichTextElementContainer__b3zGE","RichTextElement":"RMSChoosedImageElement_RichTextElement__x2xnl"};